export interface SequenceConfig {
  disabled?: boolean;
  dynamicWidth?: boolean;
  columnWidth?: number;
  maxWidth?: number;
}
